var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0022 22.543H0.997773C0.446745 22.543 0 22.0963 0 21.5453V1.13937C0 0.588284 0.446745 0.141602 0.997773 0.141602H31.0022C31.5533 0.141602 31.9999 0.588347 31.9999 1.13937V21.5453C32 22.0963 31.5533 22.543 31.0022 22.543V22.543Z",
    fill: "url(#paint0_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5018 22.0376H1.50518C0.975926 22.0376 0.546875 21.6086 0.546875 21.0793V1.60577C0.546875 1.07651 0.975926 0.647461 1.50518 0.647461H30.5018C31.031 0.647461 31.4601 1.07651 31.4601 1.60577V21.0793C31.4601 21.6086 31.0311 22.0376 30.5018 22.0376Z",
    fill: "url(#paint1_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6545 21.0638H2.34907C1.90603 21.0638 1.54688 20.7046 1.54688 20.2616V2.42231C1.54688 1.97927 1.90603 1.62012 2.34907 1.62012H29.6545C30.0975 1.62012 30.4567 1.97927 30.4567 2.42231V20.2616C30.4567 20.7046 30.0976 21.0638 29.6545 21.0638Z",
    fill: "url(#paint2_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14295 1.62012H2.34907C1.90603 1.62012 1.54688 1.97927 1.54688 2.42231V20.2616C1.54688 20.7046 1.90603 21.0638 2.34907 21.0638H4.14295V1.62012Z",
    fill: "url(#paint3_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6545 1.62012H2.34907C1.90603 1.62012 1.54688 1.97927 1.54688 2.42231V3.87524H30.4568V2.42231C30.4567 1.97927 30.0976 1.62012 29.6545 1.62012V1.62012Z",
    fill: "url(#paint4_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28787 21.0635H29.5933C30.0364 21.0635 30.3955 20.7044 30.3955 20.2614V2.42211C30.3955 2.20658 30.3101 2.01131 30.1718 1.86719L1.60156 20.6752C1.74205 20.9076 1.99642 21.0635 2.28787 21.0635V21.0635Z",
    fill: "url(#paint5_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 8.17285V22.5429H31.0001C31.5512 22.5429 31.9979 22.0962 31.9979 21.5452V18.2957L21.875 8.17285Z",
    fill: "url(#paint6_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1795 19.424H3.82295C3.44177 19.424 3.13281 19.115 3.13281 18.7338V3.9499C3.13281 3.56872 3.44177 3.25977 3.82295 3.25977H28.1794C28.5606 3.25977 28.8695 3.56872 28.8695 3.9499V18.7338C28.8696 19.115 28.5606 19.424 28.1795 19.424Z",
    fill: "url(#paint7_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 8.17285V19.4243H28.1761C28.5573 19.4243 28.8663 19.1153 28.8663 18.7342V15.1641L21.875 8.17285Z",
    fill: "url(#paint8_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.001 24.6709C21.1231 24.6709 25.2754 20.5186 25.2754 15.3965C25.2754 10.2744 21.1231 6.12207 16.001 6.12207C10.8789 6.12207 6.72656 10.2744 6.72656 15.3965C6.72656 20.5186 10.8789 24.6709 16.001 24.6709Z",
    fill: "url(#paint9_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0041 24.0726C20.7957 24.0726 24.68 20.1883 24.68 15.3967C24.68 10.6051 20.7957 6.7207 16.0041 6.7207C11.2125 6.7207 7.32812 10.6051 7.32812 15.3967C7.32812 20.1883 11.2125 24.0726 16.0041 24.0726Z",
    fill: "url(#paint10_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1481 7.09961C20.7736 8.34799 21.1262 9.75687 21.1262 11.2483C21.1262 16.3705 16.974 20.5227 11.8518 20.5227C10.3604 20.5227 8.9515 20.1702 7.70312 19.5446C9.22589 22.5837 12.3687 24.6702 15.9994 24.6702C21.1215 24.6702 25.2738 20.518 25.2738 15.3958C25.2738 11.7652 23.1872 8.62237 20.1481 7.09961V7.09961Z",
    fill: "url(#paint11_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 13.4318C19.1107 13.4318 21.6302 11.9673 21.6302 10.1607C21.6302 8.35417 19.1107 6.88965 16.0026 6.88965C12.8946 6.88965 10.375 8.35417 10.375 10.1607C10.375 11.9673 12.8946 13.4318 16.0026 13.4318Z",
    fill: "url(#paint12_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.535 9.98783C22.1595 8.84104 20.3983 8.18912 18.5612 8.18912C18.5536 8.18912 18.5459 8.18912 18.5384 8.18912L18.5039 8.18918C17.4007 8.18918 16.3156 8.03546 15.2686 7.73208C16.094 7.14498 16.9903 6.67295 17.9392 6.3259C17.4853 6.2294 17.0193 6.16609 16.5436 6.13867C15.8364 6.48433 15.1634 6.89927 14.5326 7.37958C14.5001 7.4043 14.4686 7.43028 14.4363 7.45538C13.8717 7.24437 13.3226 6.98855 12.7961 6.69133C12.5157 6.79461 12.2417 6.91094 11.9747 7.03975C12.5579 7.40424 13.1712 7.71941 13.8053 7.98087C13.2537 8.4726 12.7468 9.01315 12.2937 9.59743C12.2806 9.61425 12.2679 9.63138 12.2549 9.64832C11.2947 9.33761 10.3028 9.11674 9.29616 8.98931C9.0945 9.20026 8.90288 9.42074 8.72167 9.64995C9.7724 9.74972 10.8094 9.95571 11.8123 10.2635C11.3402 10.9648 10.944 11.7116 10.6297 12.4939C9.6956 12.3097 8.73026 12.5015 7.92437 13.0431C7.45265 13.3601 7.07072 13.7727 6.7974 14.2478C6.75084 14.6244 6.72656 15.0078 6.72656 15.3969C6.72656 16.0879 6.80274 16.761 6.94611 17.4089C6.9606 17.1295 6.99329 16.5381 7.04267 15.8519C7.10755 14.951 7.57519 14.1449 8.32587 13.6405C8.93851 13.2287 9.66598 13.0698 10.3778 13.1807C9.96816 14.4084 9.76022 15.6914 9.76022 17.0016C9.76022 19.3659 10.4585 21.6788 11.7466 23.6397C12.1612 23.8541 12.5939 24.0383 13.0419 24.189C11.3897 22.1672 10.48 19.618 10.48 17.0015C10.48 15.7561 10.6798 14.5373 11.073 13.3719C13.4551 14.2305 15.1363 16.3947 15.3735 18.9308C15.4472 19.7195 15.5424 20.2862 15.6566 20.6151C16.1571 22.0579 16.9878 23.366 18.0767 24.4378C18.3517 24.375 18.6218 24.2994 18.8869 24.2128C17.7258 23.1689 16.8465 21.8492 16.3367 20.3792C16.2442 20.1126 16.1566 19.5744 16.0902 18.8638C15.8273 16.052 13.9645 13.652 11.3243 12.6973C11.6405 11.924 12.042 11.1881 12.5225 10.5006C17.6163 12.3372 21.4177 16.7172 22.4945 22.0178C22.703 21.8133 22.9019 21.599 23.0904 21.3757C21.8491 16.1255 18.0394 11.8041 12.974 9.89949C13.4511 9.30385 13.987 8.75734 14.5735 8.26868C15.837 8.69346 17.1579 8.90899 18.5039 8.90899L18.541 8.90893H18.5617C20.801 8.90893 22.9164 9.97541 24.2237 11.7645L24.7484 12.4827L24.7965 12.4476C24.4989 11.5602 24.0708 10.7327 23.535 9.98783V9.98783Z",
    fill: "#555A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5675 8.2685C15.8309 8.69328 17.1519 8.90881 18.4979 8.90881L18.5349 8.90875H18.5557C20.3477 8.90875 22.0601 9.59236 23.3428 10.7823C22.8868 10.0577 22.327 9.40525 21.6838 8.84613C20.711 8.41896 19.6466 8.18894 18.5554 8.18894C18.5478 8.18894 18.5401 8.18894 18.5325 8.18894L18.498 8.189C17.3948 8.189 16.3097 8.03528 15.2628 7.7319C15.7797 7.36422 16.3244 7.04171 16.8924 6.7667C16.5975 6.73639 16.2981 6.7207 15.9951 6.7207C15.8144 6.7207 15.6351 6.72691 15.4572 6.73777C15.1381 6.93667 14.8275 7.15032 14.5267 7.37934C14.4941 7.40406 14.4626 7.43004 14.4304 7.45513C14.1265 7.34157 13.8273 7.21457 13.5335 7.07553C13.2152 7.16952 12.9044 7.28089 12.6025 7.40927C12.9913 7.6211 13.3909 7.81215 13.7994 7.98056C13.2479 8.4723 12.7409 9.01284 12.2878 9.59713C12.2747 9.61394 12.262 9.63107 12.249 9.64801C11.5241 9.41341 10.7811 9.23019 10.0272 9.09956C9.81509 9.30066 9.61312 9.5123 9.42218 9.73372C10.231 9.84792 11.0291 10.0245 11.8064 10.2632C11.3343 10.9645 10.938 11.7113 10.6238 12.4935C9.68967 12.3093 8.72433 12.5011 7.91843 13.0427C7.79733 13.1241 7.68239 13.2119 7.57346 13.3054C7.45851 13.7699 7.38046 14.249 7.34375 14.7398C7.56562 14.3024 7.89804 13.9237 8.31994 13.6402C8.93258 13.2284 9.66005 13.0694 10.3718 13.1804C9.96223 14.408 9.75429 15.691 9.75429 17.0012C9.75429 18.9487 10.2285 20.8609 11.1153 22.5707C11.5102 22.8398 11.9284 23.0769 12.3663 23.2788C11.14 21.4273 10.4741 19.239 10.4741 17.0012C10.4741 15.7558 10.6738 14.537 11.067 13.3716C13.4492 14.2302 15.1304 16.3944 15.3675 18.9305C15.4413 19.7192 15.5365 20.2859 15.6506 20.6148C16.0742 21.8357 16.735 22.9596 17.5878 23.926C17.8603 23.8755 18.1284 23.8125 18.3912 23.7371C17.4716 22.7791 16.7661 21.6341 16.3307 20.3789C16.2383 20.1122 16.1507 19.574 16.0843 18.8635C15.8214 16.0517 13.9585 13.6517 11.3183 12.6969C11.6346 11.9237 12.036 11.1877 12.5166 10.5002C17.3862 12.256 21.0743 16.3364 22.3304 21.3232C22.53 21.11 22.7188 20.8868 22.8962 20.6543C21.4886 15.7313 17.7996 11.7157 12.9681 9.89912C13.445 9.30361 13.981 8.7571 14.5675 8.2685V8.2685Z",
    fill: "url(#paint13_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5607 8.18847C18.5531 8.18847 18.5454 8.18847 18.5379 8.18847L18.5034 8.18853C17.4002 8.18853 16.3151 8.03481 15.2681 7.73144C15.6983 7.42549 16.1478 7.15111 16.6139 6.90904C16.4124 6.89636 16.2078 6.88965 16.0005 6.88965C15.7187 6.88965 15.442 6.90182 15.1714 6.92504C14.954 7.06935 14.7405 7.22019 14.532 7.37894C14.4995 7.40366 14.468 7.42963 14.4357 7.45473C14.1992 7.36632 13.9656 7.26957 13.7351 7.16573C13.389 7.25426 13.0612 7.36237 12.7558 7.48786C13.0979 7.66825 13.4479 7.83302 13.8048 7.98022C13.2532 8.47195 12.7463 9.0125 12.2932 9.59679C12.2801 9.6136 12.2674 9.63073 12.2544 9.64767C11.7166 9.47362 11.1685 9.32886 10.6137 9.21178C10.4989 9.43246 10.4228 9.66286 10.3906 9.90047C10.8703 9.99923 11.3449 10.1195 11.8119 10.2628C11.5096 10.7118 11.2389 11.1795 11.0005 11.663C11.1596 11.8415 11.346 12.0103 11.5567 12.1678C11.8299 11.5866 12.1523 11.0288 12.522 10.4999C14.3242 11.1497 15.9642 12.1182 17.3794 13.3328C17.6852 13.288 17.981 13.2287 18.2646 13.1561C16.7456 11.7597 14.9557 10.6443 12.9735 9.89897C13.4505 9.30333 13.9865 8.75682 14.573 8.26816C15.8364 8.69294 17.1574 8.90847 18.5034 8.90847L18.5404 8.90841H18.5612C19.6022 8.90841 20.6162 9.13919 21.5349 9.56554C21.4198 9.20181 21.2013 8.85922 20.8977 8.54832C20.1502 8.31277 19.3627 8.18847 18.5607 8.18847V8.18847Z",
    fill: "url(#paint14_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7886 12.4447C24.771 12.3921 24.7529 12.3398 24.7344 12.2877C24.7318 12.2805 24.7292 12.2733 24.7266 12.2661C24.7101 12.2201 24.6933 12.1743 24.6761 12.1286C24.6722 12.1183 24.6683 12.1081 24.6644 12.0979C24.6481 12.0551 24.6315 12.0124 24.6146 11.9699C24.61 11.9585 24.6054 11.9471 24.6009 11.9356C24.5842 11.8942 24.5672 11.853 24.55 11.8119C24.5451 11.8002 24.5401 11.7884 24.5352 11.7768C24.5177 11.7357 24.5 11.6947 24.4819 11.6538C24.477 11.6428 24.4722 11.6317 24.4672 11.6207C24.4484 11.5784 24.4292 11.5364 24.4097 11.4945C24.4054 11.4853 24.4012 11.476 24.3969 11.4669C24.3757 11.4216 24.354 11.3765 24.3321 11.3316C24.3294 11.3261 24.3268 11.3206 24.3241 11.3151C24.2229 11.1089 24.1143 10.9071 23.9986 10.7098C23.998 10.709 23.9975 10.708 23.9969 10.7072C23.9693 10.6601 23.9412 10.6133 23.9127 10.5667C23.9085 10.5597 23.9041 10.5527 23.8997 10.5458C23.8748 10.5053 23.8497 10.4651 23.8243 10.425C23.818 10.4152 23.8117 10.4054 23.8054 10.3957C23.7816 10.3585 23.7576 10.3216 23.7332 10.2848C23.7257 10.2735 23.7182 10.2622 23.7107 10.251C23.6873 10.216 23.6636 10.1811 23.6398 10.1464C23.6314 10.1342 23.6229 10.1219 23.6144 10.1097C23.591 10.0761 23.5674 10.0426 23.5435 10.0093C23.5382 10.0019 23.5329 9.99449 23.5276 9.98709C22.7026 9.2994 21.7387 8.78998 20.7031 8.49219C20.7871 8.76218 20.8595 9.03719 20.9189 9.31716C22.2276 9.78204 23.3857 10.6268 24.2168 11.7643L24.7415 12.4825L24.7895 12.4474C24.7893 12.4464 24.789 12.4456 24.7886 12.4447V12.4447Z",
    fill: "url(#paint15_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 31.8588C15.4297 31.8588 14.9487 31.4212 14.9042 30.8453C14.625 27.2316 12.5721 23.9965 9.41283 22.1913C8.88627 21.8904 8.70337 21.2197 9.00424 20.6932C9.30504 20.1666 9.97578 19.9836 10.5023 20.2846C14.2943 22.4513 16.7584 26.336 17.0937 30.6761C17.1403 31.2808 16.6881 31.8088 16.0835 31.8555C16.0548 31.8578 16.0261 31.8588 15.9978 31.8588V31.8588Z",
    fill: "url(#paint16_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6551 31.8588C11.0872 31.8588 10.6061 31.4212 10.5615 30.8455C10.2818 27.231 8.22862 23.9958 5.06927 22.1914C4.54266 21.8907 4.35963 21.2199 4.66036 20.6933C4.9611 20.1667 5.63185 19.9836 6.1584 20.2844C9.95053 22.4503 12.415 26.335 12.751 30.676C12.7978 31.2806 12.3456 31.8087 11.741 31.8555C11.7122 31.8577 11.6835 31.8588 11.6551 31.8588V31.8588Z",
    fill: "url(#paint17_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3415 31.8588C19.7735 31.8588 19.2925 31.4212 19.2479 30.8454C18.9682 27.2314 16.9154 23.9962 13.7566 22.1913C13.23 21.8904 13.0471 21.2197 13.348 20.6932C13.6488 20.1666 14.3195 19.9836 14.8461 20.2846C18.6374 22.451 21.1015 26.3356 21.4374 30.676C21.4842 31.2806 21.032 31.8088 20.4274 31.8555C20.3986 31.8577 20.3699 31.8588 20.3415 31.8588V31.8588Z",
    fill: "url(#paint18_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0055 31.8588C15.9771 31.8588 15.9486 31.8577 15.9198 31.8555C15.3151 31.8088 14.8629 31.2807 14.9096 30.6761C15.2449 26.336 17.7089 22.4512 21.5009 20.2845C22.0274 19.9836 22.6981 20.1666 22.999 20.6931C23.2998 21.2197 23.1169 21.8904 22.5904 22.1912C19.4311 23.9965 17.3783 27.2316 17.099 30.8453C17.0546 31.4211 16.5736 31.8588 16.0055 31.8588V31.8588Z",
    fill: "url(#paint19_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3493 31.8588C20.3208 31.8588 20.2922 31.8577 20.2633 31.8555C19.6587 31.8087 19.2065 31.2806 19.2533 30.676C19.5893 26.335 22.0538 22.4503 25.8459 20.2844C26.3726 19.9837 27.0432 20.1667 27.344 20.6933C27.6447 21.2199 27.4616 21.8906 26.9351 22.1914C23.7757 23.9958 21.7226 27.231 21.4428 30.8455C21.3983 31.4212 20.9172 31.8588 20.3493 31.8588V31.8588Z",
    fill: "url(#paint20_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.654 31.8588C11.6255 31.8588 11.5969 31.8577 11.568 31.8555C10.9634 31.8086 10.5112 31.2806 10.558 30.676C10.894 26.3356 13.3579 22.4509 17.1493 20.2845C17.6758 19.9836 18.3466 20.1666 18.6474 20.6931C18.9483 21.2197 18.7653 21.8904 18.2388 22.1912C15.08 23.9961 13.0273 27.2313 12.7475 30.8454C12.703 31.4212 12.2219 31.8588 11.654 31.8588V31.8588Z",
    fill: "url(#paint21_linear_152_502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3321 22.5425H5.65795C4.95803 22.5425 4.39062 21.9751 4.39062 21.2751C4.39062 20.5752 4.95803 20.0078 5.65795 20.0078H26.3321C27.0321 20.0078 27.5995 20.5752 27.5995 21.2751C27.5994 21.9751 27.032 22.5425 26.3321 22.5425V22.5425Z",
    fill: "url(#paint22_linear_152_502)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_502",
    x1: 14.0474,
    y1: 6.40231,
    x2: 24.4663,
    y2: 32.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_502",
    x1: 29.18,
    y1: 24.519,
    x2: -8.52356,
    y2: -13.1845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_502",
    x1: 14.2792,
    y1: 6.98388,
    x2: 23.4706,
    y2: 30.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_502",
    x1: 3.32726,
    y1: 11.3419,
    x2: 0.816711,
    y2: 11.3419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_502",
    x1: 16.0018,
    y1: 3.49877,
    x2: 16.0018,
    y2: 0.844901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_502",
    x1: 17.9647,
    y1: 12.7218,
    x2: 24.9456,
    y2: -14.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_502",
    x1: 29.4392,
    y1: 21.8172,
    x2: 21.9934,
    y2: 15.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_502",
    x1: 14.5318,
    y1: 7.62438,
    x2: 22.3723,
    y2: 27.4601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_502",
    x1: 30.8912,
    y1: 21.8323,
    x2: 17.8402,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_502",
    x1: 6.72656,
    y1: 15.3965,
    x2: 25.2754,
    y2: 15.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_502",
    x1: 17.0396,
    y1: 16.4322,
    x2: 7.63213,
    y2: 7.0247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_502",
    x1: 16.3215,
    y1: 18.9503,
    x2: 29.0696,
    y2: -4.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_502",
    x1: 16.6159,
    y1: 12.7588,
    x2: 14.9295,
    y2: 5.6153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45227",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_502",
    x1: 11.7068,
    y1: 10.8399,
    x2: 4.82843,
    y2: 3.73754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#D4D9E4",
    stopOpacity: 0.558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_502",
    x1: 16.0746,
    y1: 10.8119,
    x2: 15.2748,
    y2: 3.10173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "#D4D9E4",
    stopOpacity: 0.558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_502",
    x1: 22.4302,
    y1: 12.0216,
    x2: 23.222,
    y2: 8.13448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555A66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_502",
    x1: 8.85942,
    y1: 25.9993,
    x2: 17.097,
    y2: 25.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_502",
    x1: 4.51567,
    y1: 25.9992,
    x2: 12.7544,
    y2: 25.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_152_502",
    x1: 13.2032,
    y1: 25.9992,
    x2: 21.4408,
    y2: 25.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_152_502",
    x1: 23.1438,
    y1: 25.9992,
    x2: 14.9062,
    y2: 25.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_152_502",
    x1: 27.4887,
    y1: 25.9992,
    x2: 19.25,
    y2: 25.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_152_502",
    x1: 18.7923,
    y1: 25.9992,
    x2: 10.5547,
    y2: 25.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A98F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_152_502",
    x1: 15.995,
    y1: 20.196,
    x2: 15.995,
    y2: 22.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT8);
export default __webpack_public_path__ + "static/media/t8.04022f5f4819f473cf1bf708e8db4137.svg";
export { ForwardRef as ReactComponent };